const MINI_TRIAL_GUIDE_STORAGE_KEY = 'hic-mini-trial-guide-open';

// Helper functions for localStorage
export const getMiniTrialGuideOpenFromStorage = () => {
  try {
    const stored = localStorage.getItem(MINI_TRIAL_GUIDE_STORAGE_KEY);
    return stored === 'true';
  } catch (e) {
    console.error('Error reading mini trial guide state from localStorage:', e);
    return false;
  }
};
export const setMiniTrialGuideState = isOpen => {
  try {
    localStorage.setItem(MINI_TRIAL_GUIDE_STORAGE_KEY, isOpen.toString());
  } catch (e) {
    console.error('Error saving mini trial guide state to localStorage:', e);
  }
};
export const removeMiniTrialGuideStateFromStorage = () => {
  try {
    localStorage.removeItem(MINI_TRIAL_GUIDE_STORAGE_KEY);
  } catch (e) {
    console.error('Error removing mini trial guide state from localStorage:', e);
  }
};